import { makeAutoObservable } from "mobx";
import { parseWorkItemIdentifier } from "@/helpers/issue.helper";

export class RouterStore {
  params: Record<string, string> = {};
  searchParams: Record<string, string> = {};

  constructor() {
    makeAutoObservable(this, {} as never, { autoBind: true });
  }

  setParams(params: Record<string, string>): void {
    this.params = params;
  }

  setSearchParams(searchParams: Record<string, string>): void {
    this.searchParams = searchParams;
  }

  get workspaceSlug(): string | undefined {
    return this.params.workspaceSlug;
  }

  get projectId(): string | undefined {
    return this.params.projectId;
  }

  get moduleId(): string | undefined {
    return this.params.moduleId;
  }

  get teamId(): string | undefined {
    return this.params.teamId;
  }

  get dashboardId(): string | undefined {
    return this.params.id;
  }

  get eventId(): string | undefined {
    return this.params.eventId;
  }

  get fieldId(): string | undefined {
    return this.params.fieldId;
  }

  get templateId(): string | undefined {
    return this.params.templateId;
  }

  get webhookId(): string | undefined {
    return this.params.webhookId;
  }

  get issueId(): string | undefined {
    return this.params.issueId;
  }

  get viewId(): string | undefined {
    return this.params.viewId;
  }

  get workItem(): string | undefined {
    return this.params.workItem;
  }

  get parsedWorkItem(): { projectIdentifier: string; sequenceId: string } | undefined {
    const raw = this.workItem;
    if (!raw) return undefined;
    return parseWorkItemIdentifier(raw);
  }

  get notificationId(): string | undefined {
    return this.searchParams.notificationId;
  }

  get formId(): string | undefined {
    return this.params.formId;
  }

  get submissionId(): string | undefined {
    return this.params.submissionId;
  }
}
